// Keep the existing server business-time policy until gym timezone is configurable.
export const dashboardTimeZone = (currency: string) => currency === 'SAR' ? 'Asia/Riyadh' : 'Africa/Tunis';

export const dashboardBusinessDate = (date: Date, timeZone: string) => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const value = (type: string) => parts.find((part) => part.type === type)?.value ?? '';
  return `${value('year')}-${value('month')}-${value('day')}`;
};